import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  checklistKeys,
  RequestTypes,
} from '@core/react-query/features/checklists/checklist'
import { checklistsKeys } from '@core/react-query/features/checklists'
import { useMutateQueryData } from '@core/react-query/hooks'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IChecklist } from '@core/entities/checklist/Checklist'

export const getUpdateChecklistDraftMutationOptions = (
  queryClient?: QueryClient,
) => {
  const { updateInfiniteQueryItem } = useMutateQueryData(queryClient)
  return {
    ...checklistKeys.updateDraft,
    onSuccess: (checklist) => {
      updateInfiniteQueryItem(
        checklistsKeys.drafts({
          organisationId: checklist.template.organisationId,
          projectIds: [checklist.projectId],
        }).queryKey,
        checklist,
      )
    },
  }
}

export const useUpdateChecklistDraft = () => {
  const queryClient = useQueryClient()
  return useMutation<IChecklist, RequestErrorType, RequestTypes['updateDraft']>(
    getUpdateChecklistDraftMutationOptions(queryClient),
  )
}
